// import { valorMonetario } from "../../../../shared/tools/tools";
import { valorMonetario } from '@/shared/services/tools';
import { CSS_COLOR_NAMES } from './../js/CssColors';

export default class ColorCell extends HTMLElement {
    constructor(conteudoLinha, chave, monetario = false, calculaCores = () => {}){
        super();
        let container = document.createElement('div');
        let corTexto = '#000'

            let corTextoCalculado = calculaCores(conteudoLinha)
            corTexto = corTextoCalculado.toLowerCase() in CSS_COLOR_NAMES ? corTextoCalculado : `#${corTextoCalculado.replace('#', '')}`;

        container.style.color = corTexto
        container.innerText = monetario ?  valorMonetario(conteudoLinha[chave]) : conteudoLinha[chave];
        this.append(container);
    }
}

customElements.define('color-cell', ColorCell);
